import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import './App.css'
import Home from "./views/Home/index.jsx";

function App() {

  return (
      <>
          <Home/>
      </>
  )
}

export default App
